import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LeadService, metadataService } from "../_services/";
import { newLoanActions } from "../_actions";
import { SlBusyIndicator } from "../components/editors";

export class NewLoanAppLanding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leadByToken: {},
            didMount: false,
        };

        this.handleTokenValidationSuccess = this.handleTokenValidationSuccess.bind(this);
        this.handleTokenValidationFailure = this.handleTokenValidationFailure.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
    }

    componentDidMount() {
        if (this.props.hash) {
            LeadService.isValidToken(this.props.hash).then(result => {
                const leadByToken = result.data;
                if(result.status < 1) {
                    this.handleSetState({ leadByToken: leadByToken });
                    this.handleTokenValidationSuccess();
                }
                else {
                    this.handleTokenValidationFailure();
                }
            });
        }
        else {
            this.handleTokenValidationFailure();
        }
    }

    handleSetState(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        this.setState(newState);
    }

    handleTokenValidationSuccess = () => {
        const { dispatch } = this.props;

        dispatch(newLoanActions.newLoanTokenValidationSuccess(this.state.leadByToken));
    }

    handleTokenValidationFailure = () => {
        const { dispatch } = this.props;

        dispatch(newLoanActions.newLoanTokenValidationFailure(metadataService.getMessage("ErrorInvalidLeadToken")));
    }

    render() {
        return (
            <div>
                {!this.state.didMount && (
                    <SlBusyIndicator visible={!this.state.didMount} />
                )}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { hash } = ownProps.match.params;
    return {
        hash: hash,
    };
}

export default connect(mapStateToProps)(NewLoanAppLanding)




// WEBPACK FOOTER //
// ./src/components/NewLoanAppLanding.jsx